class DealOfWeekCountdown {
  constructor() {
    this.countdownElement = document.querySelector('.countdown-timer');
    if (!this.countdownElement) return;

    this.endDate = new Date(this.countdownElement.getAttribute('data-end-date')).getTime();
    this.daysElement = this.countdownElement.querySelector('[data-days]');
    this.hoursElement = this.countdownElement.querySelector('[data-hours]');
    this.minutesElement = this.countdownElement.querySelector('[data-minutes]');
    this.secondsElement = this.countdownElement.querySelector('[data-seconds]');

    this.updateCountdown();
    setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.endDate - now;

    if (distance < 0) {
      this.daysElement.textContent = '0';
      this.hoursElement.textContent = '0';
      this.minutesElement.textContent = '0';
      this.secondsElement.textContent = '0';
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.daysElement.textContent = days;
    this.hoursElement.textContent = hours.toString().padStart(2, '0');
    this.minutesElement.textContent = minutes.toString().padStart(2, '0');
    this.secondsElement.textContent = seconds.toString().padStart(2, '0');
  }
}

// Initialize countdown on page load
document.addEventListener('DOMContentLoaded', () => {
  new DealOfWeekCountdown();
});

